import {DetailFormPageShell, DetailPanel, DetailKvTable, DetailSummaryButton} from '../../../../components/detailLayout';
import Th_title from "../../../../components/Th_title";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {inspectionRequestCode} from "../InspectionCreate";
import {inspectionReportCodeType} from "../../../settings/report/InspectionReportCode/inspectionReportCodeConstants";
import UpdateFile from "../../../../components/files/UpdateFile";
import React, {useEffect, useState} from "react";
import {
    getInspection,
    getInspectionReport,
    updateInspectionReport
} from "../../../../api/maintenance/InspectionService";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {getMaintenanceAssetsFromDetail, getMaintenanceHandlersFromDetail} from "../../shared/maintenanceHandlerUtils";
import {buildReportViewGroups, groupByGroupName, groupByGroupNameWithValues} from "../../../../components/commonmethod/CommonMethod";
import {skeleton} from "../../../../redux/slice/apiSlice";
import SimmsArrayContainer from "../../../../components/drawer/simms/SimmsArrayContainer";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {dateOnChange, dateOnSelected} from "../../../../components/commonmethod/simmsDateMethod";
import {updateContract} from "../../../../api/asset/AssetContractService";
import dayjs from "dayjs";
import {cn} from "../../../../shadCn/lib/utils";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {SimmsRadio} from "../../../../components/input/SimmsRadio";
import Selector from "../../../../components/selector/Selector";
import InspectionReportItem from "./InspectionReportItem";
import InspectionReportAssetItem from "./InspectionReportAssetItem";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";

function InspectionReportUpdate(){

    const { id } = useParams();
    const dispatch = useDispatch();
    const [type, setType] = useState();
    const [inspection, setInspection] = useState({});
    const [handler, setHandler] = useState([]);
    const [assets, setAssets] = useState([]);
    const [inspectionReport, setInspectionReport] = useState({});
    const navigate = useNavigate();
    const [view, setView] = useState();

    //Todo 개선방안 필요
    useEffect(() =>{
        Promise.all([
            getInspection(id),
        ]).then(([inspectionResponse]) => {
            if(inspectionResponse.status === 200){

                const settings = localStorage.getItem("setting");
                const result = JSON.parse(settings)?.find(e => e.globalsNmAsSnake === "inspectionReport")?.globalsValue === "true";
                setView(result);

                if(inspectionResponse.status === 201) {
                    if (inspectionResponse.data.errorCode = 'AUTHORITY') {
                        alert(inspectionResponse.data.reason)
                        navigate(-1)
                    }
                }

                const resolvedAssets = getMaintenanceAssetsFromDetail(inspectionResponse.data);

                setInspection(inspectionResponse.data);
                getInspectionReport(id).then((reportResponse) => {
                    setType(reportResponse.data.inspectionReportCode.reportCode);

                    const report = reportResponse.data;

                    const children = report.inspectionReportCode.children;
                    const assetView = report.assetView;
                    const reportView = report.reportView;

                    // groupName 기준으로 child 구성
                    const assetGroup = groupByGroupNameWithValues(children, assetView);
                    const reportGroup = buildReportViewGroups(children, reportView);

                    // 상태 반영
                    setInspectionReport({
                        ...report,
                        assetView: assetGroup,
                        reportView : reportGroup
                    });

                    // 없는 항목에 대한 초기값 세팅이 필요할 듯 아니면 비어있음
                    if (result && reportResponse.data.assetView.length == 0){
                        initAsset(reportResponse.data.inspectionReportCode.children, resolvedAssets);
                    }else if(!result && reportResponse.data.reportView.length == 0){
                        initReport(reportResponse.data.inspectionReportCode.children);
                    }
                });

                setAssets(resolvedAssets);
                setHandler(getMaintenanceHandlersFromDetail(inspectionResponse.data));
            }
        }).finally(
            dispatch(skeleton(false))
        )
    }, [id, dispatch])

    const update = async ()=>{
        if(!inspectionReport.inspectionReportCode?.id){
            alert("점검내용 코드구분을 선택해주세요")
            return
        }

        const updatedChildren = inspectionReport.reportView?.flatMap(group =>
            group.child.map(item => ({ ...item }))
        );

        const updatedAssetViewChildren = inspectionReport.assetView?.flatMap(group =>
            group.child.map(item => ({ ...item }))
        );

        // view 조건에 따라 필요한 필드만 포함
        const data = {
            ...inspectionReport,
            inspection: { id: inspection.id },
            inspectionReportCode: { id: inspectionReport.inspectionReportCode.id },
            assetView: view && updatedAssetViewChildren?.length > 0 ? updatedAssetViewChildren : [],
            reportView: !view && updatedChildren?.length > 0 ? updatedChildren : []
        };

        const response = await updateInspectionReport(data);
        if(response.status === 200){
            alert("수정되었습니다.")
            navigate("/maintenance/inspection/"+inspection.id);
        }
    }

    const movePage={
        url:"/maintenance/inspection/"+inspection.id,
        content : "상세페이지"
    }

    const onChangeConnectedInfo = (each, assetList) => {
        if(inspectionReport.inspectionReportCode?.id === each.id){
            setInspectionReport(prev => {
                const newState = { ...prev };
                delete newState.inspectionReportCode;
                delete newState.assetView;
                delete newState.reportView;

                return newState;
            });

            return;
        }else{
            setInspectionReport((prev) => ({
                ...prev,
                inspectionReportCode : each
            }))
        }

        if (view === true) {
            initAsset(each.children, assetList);
        }else{
            initReport(each.children);
        }
    };

    function initAsset(list, assetList) {
        const groupList = groupByGroupName(list); // [{ groupName, child: [...] }, ...]

        const remain = groupList.map(group => ({
            ...group,
            child: group.child.flatMap(item => {
                if (parseInt(item.type) === 1) {
                    return assetList.map(e => ({
                        assetId: e.id,
                        codeId: item.id,
                        value: 0
                    }));
                }
                return []; // type !== 1인 경우는 제외
            })
        }));

        setInspectionReport((prev) => ({...prev, assetView : remain}))
    }

    function initReport(list) {
        setInspectionReport((prev) => ({...prev, reportView: buildReportViewGroups(list)}));
    }

    if(Object.keys(inspectionReport).length > 0) {
        const summaryMeta = [
            inspection.title,
            inspectionReport.inspectionReportCode?.name,
        ]
            .filter(Boolean)
            .join(" · ");

        return (
            <DetailFormPageShell
                className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout"
                title="점검 보고서 수정"
                meta={summaryMeta || undefined}
                actions={
                    <>
                        <DetailSummaryButton muted onClick={() => navigate(movePage.url)}>
                            취소
                        </DetailSummaryButton>
                        <DetailSummaryButton className="ml-1" onClick={update}>
                            저장
                        </DetailSummaryButton>
                    </>
                }
            >
                    <DetailPanel title={"점검요청자산"}>
                        <DetailKvTable>
                            <tbody>
                                <tr>
                                    <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                                        <SimmsArrayContainer data={assets} entity={'asset'} readonly />
                                    </Th_title>
                                </tr>
                            </tbody>
                        </DetailKvTable>
                    </DetailPanel>

                    <DetailPanel title={"점검요청정보"}>
                        <DetailKvTable>
                            <tbody>
                                <tr>
                                    <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"createdAt"} value={inspection.createdAt} />
                                    </Th_title>
                                    <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"createdBy"} value={inspection.createdBy} />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"updatedAt"} value={inspection.updatedAt} />
                                    </Th_title>
                                    <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"updatedBy"} value={inspection.updatedBy} />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"점검 제목"} colspan={3} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"title"} value={inspection.title} />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"requester"} value={inspection.requester} />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                        <SimmsArrayContainer data={handler} entity={'userAccount'} readonly />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"점검코드"} colspan={1} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"inspectCode"} value={inspection.inspectCode?.name} />
                                    </Th_title>
                                    <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                                        <ReadOnlyInputBasic target={"requestCode"} value={ inspectionRequestCode.find(data => data.id === inspection.requestCode) } />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"점검기간"} colspan={3} className="fieldset-td fieldset-td-input">
                                        <div className={"flex"}>
                                            <SimmsDatePicker
                                                onChange={(v)=>dateOnChange(setInspection,"inspectStartDate", v, false)}
                                                data={inspection.inspectStartDate}
                                                update onUpdate={(v)=>dateOnSelected(setInspection, updateContract, inspection.id, "inspectStartDate", v, false)}
                                                constraint={{lessThan : inspection.inspectEndDate && dayjs(inspection.inspectEndDate)}} auth readonly />
                                            <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                            <SimmsDatePicker
                                                onChange={(v)=>dateOnChange(setInspection,"inspectEndDate", v, false)}
                                                data={inspection.inspectEndDate}
                                                update onUpdate={(v)=>dateOnSelected(setInspection, updateContract, inspection.id, "inspectEndDate", v, false)}
                                                constraint={{largerThan : inspection.inspectStartDate && dayjs(inspection.inspectStartDate)}} auth readonly />
                                        </div>
                                    </Th_title>
                                </tr>
                            </tbody>
                        </DetailKvTable>
                    </DetailPanel>
                
                    <DetailPanel title={"점검내용"}>
                        <DetailKvTable>
                            <tbody>
                                <tr>
                                    <Th_title title={"점검결과"} colspan={3} className="fieldset-td">
                                        <SimmsTextArea onChange={(v)=>inputOnChange(setInspectionReport,"inspectionResult", v, false)} data={inspectionReport.inspectionResult} style={{width: "100%"}} />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"코드 구분"} colspan={3} className="fieldset-td">
                                        <SimmsRadio
                                            title="코드 구분"
                                            options={inspectionReportCodeType}
                                            data={type}
                                            onChange={(v) => {
                                                setType(v);
                                                delete inspectionReport.reportView;
                                                delete inspectionReport.assetView;
                                                delete inspectionReport.inspectionReportCode;
                                            }}
                                        />
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"보고서 코드"} colspan={3} className="fieldset-td">
                                        <Selector
                                            onChange={(v)=>onChangeConnectedInfo(v, assets)}
                                            data={inspectionReport.inspectionReportCode}
                                            entity={type == "company" ? "inspectionReportCompany" : "inspectionReportAsset"}
                                            uniqueKey={type}
                                            auth
                                        >
                                            <SimmsInputSearch type={'TEXT'} placeHolder={"코드명"} />
                                        </Selector>
                                    </Th_title>
                                </tr>
                            </tbody>
                        </DetailKvTable>
                    </DetailPanel>

                    <InspectionReportItem view={view} obj={inspectionReport} status={"update"} setter={setInspectionReport} />
                    <InspectionReportAssetItem view={view} obj={inspectionReport} status={"update"} asset={assets} setter={setInspectionReport} />
                
                    {/*파일 업로드*/}
                    <DetailPanel title={"파일업로드"}>
                        <UpdateFile className={"update-image"} tableInfo={{tableName: "inspection_report", joinKey: inspectionReport.id}}/>
                    </DetailPanel>

            </DetailFormPageShell>
        )
    }
}

export {InspectionReportUpdate}